import apiClient from "../apiClient";

export const PayrollAPI = {
  getAllAllowanceTypesPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(
      `/api/v1/payroll/allowance-type/list?${searchParams.toString()}`
    );
  },
  getAllDeductionTypesPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(
      `/api/v1/payroll/deduction-type/list?${searchParams.toString()}`
    );
  },
  createAllowanceType: ({ code, description, deminimis }) =>
    apiClient.post("/api/v1/payroll/allowance-type/create", {
      Code: code,
      Description: description,
      Deminimis: deminimis,
    }),
  createDeductionType: ({ code, description, statutory }) =>
    apiClient.post("/api/v1/payroll/deduction-type/create", {
      Code: code,
      Description: description,
      Statutory: statutory,
    }),

  getAllowanceTypeById: (id) =>
    apiClient.get(`/api/v1/payroll/allowance-type/list/${id}`),
  getDeductionTypeById: (id) =>
    apiClient.get(`/api/v1/payroll/deduction-type/list/${id}`),
  updateAllowanceType: ({ id, code, description, deminimis }) =>
    apiClient.put(`/api/v1/payroll/allowance-type/update/${id}`, {
      Code: code,
      Description: description,
      Deminimis: deminimis,
    }),
  updateDeductionType: ({ id, code, description, statutory }) =>
    apiClient.put(`/api/v1/payroll/deduction-type/update/${id}`, {
      Code: code,
      Description: description,
      Statutory: statutory,
    }),

  getAllEmployeeSalaryRecordsPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(
      `/api/v1/payroll/salary-record/list?${searchParams.toString()}`
    );
  },
  createEmployeeSalaryRecord: (payload) => {
    return apiClient.post(`/api/v1/payroll/salary-record/create`, payload);
  },
  updateEmployeeSalaryRecord: ({ id, payload }) => {
    return apiClient.put(`/api/v1/payroll/salary-record/update/${id}`, payload);
  },
  getSalaryRecordById: (id) =>
    apiClient.get(`/api/v1/payroll/salary-record/list/${id}`),
  deleteAllowanceTypeById: (id) =>
    apiClient.delete(`/api/v1/payroll/allowance-type/delete/${id}`),
  deleteDeductionTypeById: (id) =>
    apiClient.delete(`/api/v1/payroll/deduction-type/delete/${id}`),
};
